import { createFileRoute, redirect } from "@tanstack/react-router";

import { authClient } from "@/lib/auth-client";

export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    const session = await authClient.getSession();

    if (!session.data) {
      throw redirect({
        to: "/login",
        search: {
          mode: undefined,
          token: undefined,
          error: undefined,
          redirect: undefined,
          email: undefined,
        },
      });
    }

    // Redirect authenticated users to dashboard (main entry point)
    throw redirect({ to: "/dashboard" });
  },
});
